/*********************************************************************************************
 * No scroll
    *
 */
// function enableScrollControl(selector) {
//     // Sélectionner tous les éléments correspondants au sélecteur
//     const elements = document.querySelectorAll(selector);

// function enableScrollControl(selector) {
//     // Sélectionner tous les éléments correspondants au sélecteur
//     const elements = document.querySelectorAll(selector);

//     // Fonction pour empêcher le défilement global
//     function preventScroll(event) {
//         // Vérifier si l'élément cible est un enfant de data-scroll
//         const scrollableParent = event.target.closest('[data-scroll]');

//         if (scrollableParent) {
//             // Vérifie si le défilement est possible dans l'élément
//             const delta = event.deltaY || -event.wheelDelta || event.detail;
//             const atTop = scrollableParent.scrollTop === 0 && delta < 0;
//             const atBottom =
//                 scrollableParent.scrollHeight - scrollableParent.scrollTop === scrollableParent.clientHeight &&
//                 delta > 0;

//             if (atTop || atBottom) {
//                 // Bloquer le défilement si on est en haut ou en bas
//                 event.preventDefault();
//             }
//         } else {
//             // Bloquer tout autre défilement global
//             event.preventDefault();
//         }
//     }

//     // Ajouter les écouteurs d'événements pour chaque élément correspondant
//     elements.forEach(element => {
//         element.addEventListener('mouseenter', function() {
//             // Bloque le défilement global, mais autorise celui des enfants scrollables
//             window.addEventListener('wheel', preventScroll, { passive: false });
//             window.addEventListener('mousewheel', preventScroll, { passive: false });
//             window.addEventListener('touchmove', preventScroll, { passive: false });
//         });

//         element.addEventListener('mouseleave', function() {
//             // Réactiver le défilement global
//             window.removeEventListener('wheel', preventScroll);
//             window.removeEventListener('mousewheel', preventScroll);
//             window.removeEventListener('touchmove', preventScroll);
//         });
//     });
// }

// // Appliquer le contrôle de défilement aux éléments avec l'attribut data-no-scroll
// enableScrollControl('[data-no-scroll]');


// LOADER ************************************************************************************
/*********************************************************************************************
* Add a loading state to the specified button.
	*
	* @param {HTMLElement} elem - The element to which the 'mm-loading' class will be added.
*/
const mmLoadThis = (elem) => elem.classList.add('mm-loading');

// MEGAMENU **********************************************************************************
/*********************************************************************************************
* Hide specified elements and show the specified element.
	*
	* @param {string} classElemsToHide - The CSS selector for the elements to hide.
	* @param {string} classElemToShow - The CSS selector for the element to show.
*/
const mmMegaMenuShowProducts = (classElemsToHide, classElemToShow) => {
    document.querySelectorAll(classElemsToHide).forEach(elem => elem.style.display = 'none');
    document.querySelector(classElemToShow).style.display = 'grid';
};

/*********************************************************************************************
* Adjust the position of the mega menu based on the header height.
	*
*/
const getMegaMenuPosition = () => {
    const header = document.querySelector('[data-mm-header]');
    if (!header) return;

    const headerHeight = header.offsetHeight;
    document.querySelectorAll('[data-megamenulink]').forEach(menuElem => {
        const megaMenu = menuElem.nextElementSibling;
        if (megaMenu?.hasAttribute('data-megamenu')) {
            megaMenu.style.top = `${headerHeight - 1}px`;
        }
    });
};

// BACKGROUND FILTER *************************************************************************
/*********************************************************************************************
* Add background filter on hover over mega menu links.
	*
*/
const hoverBgFilter = () => {
    const header = document.querySelector('[data-mm-header]');
    const searchContainer = document.querySelector('[data-search-container]');
    const megaMenuLinks = document.querySelectorAll('[data-megamenulink]');
    const menuLinks = document.querySelectorAll('[data-menulink]');
    const filter = document.querySelector('[data-filter]');
    const cart = document.querySelector('[data-cart-filter]');

    if (!header || !filter || !cart) return;

    const toggleFilter = (show) => {
        filter.classList.toggle("active", show);
    };

    megaMenuLinks.forEach(link => link.addEventListener('mouseenter', () => toggleFilter(true)));
    menuLinks.forEach(link => link.addEventListener('mouseenter', () => toggleFilter(false)));

    header.addEventListener('mouseleave', () => {
        if ((!searchContainer || !searchContainer.classList.contains('mm-open')) &&
            !cart.classList.contains('mm-dc-is-open')) {
            toggleFilter(false);
        }
    });
}

/*********************************************************************************************
* Show background filter.
	*
*/
const showBgFilter = (zIndex) => {
    const filter = document.querySelector('[data-filter]');
    if (!filter) return;
    filter.classList.add("active");
    if (zIndex) filter.style.zIndex = zIndex;
}

/*********************************************************************************************
* Hide background filter.
	*
*/
const hideBgFilter = () => {
    const filter = document.querySelector('[data-filter]');
    if (!filter) return;
    setTimeout(() => filter.style.removeProperty('z-index'), 700);
    filter.classList.remove("active");
};

// EXTERNAL LINK *****************************************************************************
/*********************************************************************************************
* Open external links in a new tab unless it's the consent modale.
	*
*/
const externalLink = () => {
    document.querySelectorAll('a:not(.consent-wrapper)').forEach(link => {
        if (link.hostname !== window.location.hostname) {
            link.target = '_blank';
            link.rel = 'noreferrer noopener';
        }
    });
};

// MENU MOBILE *******************************************************************************
/*********************************************************************************************
/*********************************************************************************************
* Toggle the mobile menu.
	*
*/
function mmMobileMenu() {
    const header = document.querySelector("header");
    const mobileMenu = document.querySelector("[data-menu-mobile]");
    let headerMenu = document.querySelector('.mm-header');
    let headerHeight = headerMenu.offsetHeight;
    let headerMenuTop = headerMenu.getBoundingClientRect().top;

        document.querySelector("html").classList.add("stop-scrolling");

    showBgFilter();
    header.classList.toggle("mm-open");
    mobileMenu.classList.toggle("mm-menu-open");
    mobileMenu.style.height = `calc(var(--doc-height) - (${headerHeight}px + ${headerMenuTop}px))`;
}


/*********************************************************************************************
* Close the mobile menu.
	*
*/
function mmCloseMobileMenu() {

    const header = document.querySelector("header");
    const mobileMenu = document.querySelector("[data-menu-mobile]");

    if (mobileMenu.classList.contains("mm-menu-open")) {
        header.classList.remove("mm-open");
        mobileMenu.classList.remove("mm-menu-open");
    
            document.querySelector("html").classList.remove("stop-scrolling");
    
        hideBgFilter();
    }
}

/*********************************************************************************************
* Handle tooltips behavior, with click on mobile and hover on desktop
    *
*/
const handleTooltips = () => {
    const tooltips = document.querySelectorAll('.mm-tooltip');
    
    tooltips.forEach(tooltip => {
        tooltip.addEventListener('click', function(e) {
            e.preventDefault();
            // Ferme tous les autres tooltips
            tooltips.forEach(t => {
                if (t !== tooltip) t.classList.remove('active');
            });
            // Toggle le tooltip cliqué
            tooltip.classList.toggle('active');
        });
    });

    // Ferme le tooltip si on clique ailleurs sur la page
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.mm-tooltip')) {
            tooltips.forEach(tooltip => tooltip.classList.remove('active'));
        }
    });
};

/*********************************************************************************************
* Show the next sub-menu in the mobile menu.
	*
	* @param {string} elemToShowClass - The CSS selector of the element to show.
*/
const mmMobileMenuShowNext = (elemToShowClass) => {
    document.querySelector(elemToShowClass)?.classList.add('mm-mobile-menu-elem-slided');
};

/*********************************************************************************************
* Show the previous sub-menu in the mobile menu.
	*
	* @param {string} elemToShowClass - The CSS selector of the element to show.
*/
const mmMobileMenuShowPrev = (elemToShowClass) => {
    document.querySelector(elemToShowClass)?.classList.remove('mm-mobile-menu-elem-slided');
};

// DROPDOWN **********************************************************************************
/*********************************************************************************************
* Handle dropdown behavior.
	*
*/
const handleDropdown = () => {
  const dropContainers = document.querySelectorAll(".mm-dropdown-container");
  dropContainers.forEach((dropContainer) => {
    const dropWrappers = dropContainer.querySelectorAll('[data-drop="dropdown"]');

    dropWrappers.forEach((item) => {
        item.addEventListener('click', function() {
          console.log(item);

            dropWrappers.forEach((el) => {
                if (el !== this) {
                    el.classList.remove('active');
                    if (el.nextElementSibling) el.nextElementSibling.style.maxHeight = null;
                }
            });

            this.classList.toggle('active');
            const content = this.nextElementSibling;

            if (content) {
                content.style.maxHeight = this.classList.contains('active') ? `${content.scrollHeight}px` : 0;
            }
        });
    });
  });
};

// SEARCH ************************************************************************************
/*********************************************************************************************
* Show the search bar and related UI changes.
	*
	* @param {HTMLElement} clickedElem - The element that was clicked to show the search bar.
*/
const mmShowSearch = () => {
    const elements = {
        search: document.querySelector('[data-search-container]'),
        html: document.documentElement,
        searchInput: document.getElementById('Search')
    };

    if (Object.values(elements).some(el => !el)) return;

    const { search, html, searchInput } = elements;

    const searchFilter = document.querySelector('[data-search-container-filter]');

        document.querySelector("html").classList.add("stop-scrolling");

    search.classList.add('mm-open');
    searchFilter.classList.add('mm-open');
    // showBgFilter();

    setTimeout(() => searchInput.focus(), 1000);

    document.getElementById('predictive-search')?.addEventListener("touchstart", () => {
        setTimeout(() => searchInput.blur(), 500);
    });
}

/*********************************************************************************************
* Hide the search bar and revert UI changes.
	*
	* @param {HTMLElement} clickedElem - The element that was clicked to hide the search bar.
*/
const mmHideSearch = (keepFilterActive = false) => {
    const elements = {
        search: document.querySelector('[data-search-container]'),
        html: document.documentElement,
        searchInput: document.getElementById('Search')
    };

    if (Object.values(elements).some(el => !el)) return;

    const { search, html, searchInput } = elements;

    const searchFilter = document.querySelector('[data-search-container-filter]');

    html.classList.remove('stop-scrolling');
    search.classList.remove('mm-open');
    searchFilter.classList.remove('mm-open');
    // if (!keepFilterActive) hideBgFilter();

    searchInput.value = '';
    searchInput.dispatchEvent(new Event('input'));
}




/*********************************************************************************************
	* Initialize parallax effect for slide images.
	*
*/
const mmInitParallax = () => {
    const images = document.querySelectorAll(".mm-slide-image");
    if (!images.length) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const slideImage = entry.target;
                const covers = slideImage.querySelectorAll(".mm-slide-image-cover");
                if (!covers.length) return;

                covers.forEach(cover => {
                    gsap.to(cover, {
                        yPercent: 30,
                        ease: "none",
                        scrollTrigger: {
                            trigger: slideImage,
                            start: "top bottom",
                            end: "bottom top",
                            scrub: true
                        }
                    });
                });

                observer.unobserve(slideImage);
            }
        });
    }, {
        rootMargin: "0px 0px 200px 0px"
    });

    images.forEach(image => observer.observe(image));
};

/*********************************************************************************************
* Handles lazy loading of videos based on viewport size
	*
*/
const mmInitVideoLazy = () => {
    const videos = document.querySelectorAll('.mm-video-lazy');
    if (!videos.length) return;

    const loadVideo = (video) => {
        if (!video.playing) {
            video.preload = 'auto';
            video.autoplay = true;
            video.play().catch(() => {
                // Handle autoplay failure
            });
        }
    };

    const unloadVideo = (video) => {
        video.pause();
        video.preload = 'none';
        video.autoplay = false;
        video.currentTime = 0;
    };

    const handleVideoVisibility = () => {
        const isMobile = window.matchMedia('(max-width: 768px)').matches;

        videos.forEach(video => {
            const isDesktop = video.classList.contains('mm-desktop');
            const isMobileVideo = video.classList.contains('mm-mobile');

            // If video has neither desktop nor mobile class, it's a universal video
            if (!isDesktop && !isMobileVideo) {
                loadVideo(video);
            } else if ((isDesktop && !isMobile) || (isMobileVideo && isMobile)) {
                loadVideo(video);
            } else {
                unloadVideo(video);
            }
        });
    };

    // Initial load
    handleVideoVisibility();

    // Handle resize with debounce
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleVideoVisibility, 250);
    });
};

/*********************************************************************************************
* Set the document height CSS variable to the current window height.
	*
*/
const documentHeight = () => {
    document.documentElement.style.setProperty('--doc-height', `${window.innerHeight}px`);
}

/*********************************************************************************************
* Custom element for product recommendations
	*
*/
class ProductRecommendations extends HTMLElement {
    connectedCallback() {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    observer.unobserve(this);
                    this.loadRecommendations();
                }
            },
            { rootMargin: "0px 0px 400px 0px" }
        );

        observer.observe(this);
    }

    async loadRecommendations() {
        try {
            const response = await fetch(this.dataset.url);
            const text = await response.text();
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("product-recommendations");

            if (recommendations?.innerHTML.trim()) {
                this.innerHTML = recommendations.innerHTML;
            }
        } catch (error) {
            console.error('Error loading product recommendations:', error);
        }
    }
}

customElements.define("product-recommendations", ProductRecommendations);

// DOM ***************************************************************************************
/*********************************************************************************************
* Loaded Listenner
	*
*/
document.addEventListener('DOMContentLoaded', () => {
    getMegaMenuPosition();
    hoverBgFilter();
    externalLink();
    handleDropdown();
    documentHeight();
	mmInitParallax();
	mmInitVideoLazy();
	handleTooltips();
});

/*********************************************************************************************
* Resized Listenner
	*
*/
window.addEventListener('resize', () => {
    getMegaMenuPosition();
    documentHeight();
});


/*********************************************************************************************
* Video play / pause
    *
*/
function playVideo(element) {
    const video = element.querySelector('video');
    if (video) {
        video.play();
    }
}

function pauseVideo(element) {
    const video = element.querySelector('video');
    if (video) {
        video.pause();
    }
}

/*********************************************************************************************
* Search
    *
*/
const headerLeft = document.querySelector('.mm-header-left');
const headerRight = document.querySelector('.mm-header-right-link');

if (headerLeft) {
    headerLeft.addEventListener('mouseenter', () => {
        mmHideSearch(); 
    });
}

if (headerRight) {
    headerRight.addEventListener('mouseenter', () => {
        mmHideSearch();
    });
}